import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-guest-user-info-modal',
  templateUrl: './guest-user-info-modal.component.html'
})
export class GuestUserInfoModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { guestForm: FormGroup },
    public dialogRef: MatDialogRef<GuestUserInfoModalComponent>
  ) { }

  submit() {
    if (this.data.guestForm.valid) {
      this.dialogRef.close(this.data.guestForm.value);
    }
  }

  onGuestKeyUpOfPhone(event?: any) {
    const ignoreKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'ArrowDown', 'ArrowUp', 'Delete', 'Tab'];
    if (event?.key && ignoreKeys.includes(event.key)) {
      return;
    }

    let phoneString = this.data.guestForm.get('phoneNumber')?.value || '';
    phoneString = phoneString.toString().replace(/[^0-9]/g, '');

    if (event?.clipboardData?.getData) {
      const pastedData = event.clipboardData.getData('text/plain');
      const pastedDigits = pastedData.replace(/[^0-9]/g, '');
      phoneString += pastedDigits;
    }

    this.formatAndSetPhoneNumberForGuest(phoneString);
  }

  formatAndSetPhoneNumberForGuest(phoneString: string) {
    let newFormattedPhoneString = '';
    if (phoneString.length > 0) {
      newFormattedPhoneString += "(" + phoneString.substr(0, 3);
    }
    if (phoneString.length > 3) {
      newFormattedPhoneString += ") " + phoneString.substr(3, 3);
    }
    if (phoneString.length > 6) {
      newFormattedPhoneString += "-" + phoneString.substr(6, 4);
    }

    this.data.guestForm.get('phoneNumber')?.setValue(newFormattedPhoneString, { emitEvent: false });
  }
  
}
